import { CALL_API } from '../middleware/api'

export const OPS_DASHBOARD_REQUEST = 'OPS_DASHBOARD_REQUEST'
export const OPS_DASHBOARD_SUCCESS = 'OPS_DASHBOARD_SUCCESS'
export const OPS_DASHBOARD_FAILURE = 'OPS_DASHBOARD_FAILURE'

// Sales-based operational dashboard data (ADMIN MASTER). Resolves to
// { type, response } or { type, error }; the view keeps it in local state.
export function fetchOpsDashboard(StartDate, EndDate) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `ops-dashboard?StartDate=${StartDate}&EndDate=${EndDate}`,
      authenticated: true,
      types: [OPS_DASHBOARD_REQUEST, OPS_DASHBOARD_SUCCESS, OPS_DASHBOARD_FAILURE]
    }
  }
}

export const SALES_SUMMARY_REQUEST = 'SALES_SUMMARY_REQUEST'
export const SALES_SUMMARY_SUCCESS = 'SALES_SUMMARY_SUCCESS'
export const SALES_SUMMARY_FAILURE = 'SALES_SUMMARY_FAILURE'

// Sales-only summary (same totals as the Ventas page) for the admin
// "Dashboard Ventas" (/pro-dashboard). Resolves to { type, response | error }.
export function fetchSalesSummary(StartDate, EndDate) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `ops-dashboard/sales?StartDate=${StartDate}&EndDate=${EndDate}`,
      authenticated: true,
      types: [SALES_SUMMARY_REQUEST, SALES_SUMMARY_SUCCESS, SALES_SUMMARY_FAILURE]
    }
  }
}
